import { COLOR_BLACK, COLOR_WHITE } from "../../../constants"

export const getOrCreateTooltip = (chart: any) => {
  let tooltipEl = chart.canvas.parentNode.querySelector("div")
  if (!tooltipEl) {
    tooltipEl = document.createElement("div")
    tooltipEl.id = "chartjs-tooltip"
    tooltipEl.style.position = "absolute"
    tooltipEl.style.backgroundColor = COLOR_WHITE
    tooltipEl.style.color = COLOR_BLACK
    tooltipEl.style.border = "1px solid rgba(0, 0, 0, 0.1)"
    tooltipEl.style.borderRadius = "4px"
    tooltipEl.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.2)"
    tooltipEl.style.padding = "8px"
    tooltipEl.style.pointerEvents = "auto"
    tooltipEl.style.maxHeight = "200px"
    tooltipEl.style.overflowY = "auto"
    tooltipEl.style.zIndex = "9999"
    tooltipEl.style.opacity = "0"
    tooltipEl.style.transition = "opacity 0.6s ease"

    // Prevent the tooltip from disappearing when hovered
    tooltipEl.addEventListener("mouseenter", () => {
      tooltipEl.style.opacity = "1"
    })
    tooltipEl.addEventListener("mouseleave", () => {
      tooltipEl.style.opacity = "0"
    })
    chart.canvas.parentNode.appendChild(tooltipEl)
  }

  return tooltipEl
}
